import { CSSObject } from 'libs/ui/styled';

import { ChipSize } from '../types';

export const CHIP_SIZES: Record<ChipSize, CSSObject> = {
  s: { padding: '3px 12px' },
  m: { padding: '4px 16px' },
  xs: { padding: '3px 8px' },
};
